import React, { FC } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Box from '@mui/material/Box'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'

interface UnsavedChangesDialogProps {
  open: boolean
  onStay: () => void
  onLeave: () => void
}

const UnsavedChangesDialog: FC<UnsavedChangesDialogProps> = ({
  open,
  onStay,
  onLeave,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onStay}
      aria-labelledby="unsaved-changes-dialog-title"
      aria-describedby="unsaved-changes-dialog-description"
    >
      <DialogTitle id="unsaved-changes-dialog-title">
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningAmberIcon color="warning" />
          Unsaved Changes
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="unsaved-changes-dialog-description">
          You have unsaved changes. Are you sure you want to leave this page?
          Your changes will be lost.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onStay} color="info" variant="contained">
          Stay on Page
        </Button>
        <Button onClick={onLeave} color="error">
          Leave Anyway
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default UnsavedChangesDialog
